import React, { createContext, FC, useContext, useMemo, useState } from 'react';

type TrackingDecorationActionsContextType = {
  enablePersonalisedDecoration: (value: boolean) => void;
};

type TrackingDecorationContextType = {
  hasPersonalisedDecoration: boolean;
};

const TrackingDecorationContext = createContext<TrackingDecorationContextType>({
  hasPersonalisedDecoration: false,
});
const TrackingDecorationActionsContext = createContext({
  enablePersonalisedDecoration: (_value: boolean) => {},
});

const TrackingDecorationProvider: FC = ({ children }) => {
  const [hasPersonalisedDecoration, setHasPersonalisedDecoration] =
    useState(false);

  const actions = useMemo(
    () => ({
      enablePersonalisedDecoration: (value: boolean): void =>
        setHasPersonalisedDecoration(value),
    }),
    [setHasPersonalisedDecoration]
  );

  return (
    <TrackingDecorationContext.Provider value={{ hasPersonalisedDecoration }}>
      <TrackingDecorationActionsContext.Provider value={actions}>
        {children}
      </TrackingDecorationActionsContext.Provider>
    </TrackingDecorationContext.Provider>
  );
};

export const useTrackingDecoration = (): TrackingDecorationContextType =>
  useContext(TrackingDecorationContext);
export const useTrackingDecorationActions =
  (): TrackingDecorationActionsContextType =>
    useContext(TrackingDecorationActionsContext);

export default TrackingDecorationProvider;
